export const DASHBOARD = 'dashboard';
export const USERS = 'users';
export const USERS_ADD = 'users_add';
export const USERS_EDIT = 'users_edit';
export const REPORTS = 'reports';
export const REPORTS_ADD = 'reports_add';
export const ACTIVITY = 'activity';
export const WEBSITE = 'website';
export const PROFILE = 'profile';
export const LOGIN = 'login';

export const KEY_LABEL = {
  [DASHBOARD]: 'Dashboard',
  [USERS]: 'Users',
  [REPORTS]: 'Reports',
  [WEBSITE]: 'GeneID Site',
  [PROFILE]: 'Your Profile',
  [ACTIVITY]: 'Activity Log',
  [LOGIN]: 'Login',
};

export const PATH_NAME = {
  [DASHBOARD]: '/',
  [USERS]: '/users',
  [USERS_ADD]: '/users/add',
  [USERS_EDIT]: '/users/edit',
  [REPORTS]: '/reports',
  [REPORTS_ADD]: '/reports/add',
  [PROFILE]: '/profile',
  [LOGIN]: '/login',
  [ACTIVITY]: '/activity',
};

export const PATH_LABEL = {
  [PATH_NAME[DASHBOARD]]: 'Dashboard',
  [PATH_NAME[USERS]]: 'Users',
  [PATH_NAME[USERS_ADD]]: 'Add User',
  [PATH_NAME[USERS_EDIT]]: 'Edit User',
  [PATH_NAME[REPORTS]]: 'Reports',
  [PATH_NAME[REPORTS_ADD]]: 'Add Report',
  [PATH_NAME[PROFILE]]: 'Your Profile',
  [PATH_NAME[LOGIN]]: 'Login',
  [PATH_NAME[ACTIVITY]]: 'Activity Log',
};

export const PATHS = [
  {
    key: DASHBOARD,
    path: PATH_NAME[DASHBOARD],
    text: KEY_LABEL[DASHBOARD],
  },
  {
    key: USERS,
    path: PATH_NAME[USERS],
    text: KEY_LABEL[USERS],
  },
  {
    key: REPORTS,
    path: PATH_NAME[REPORTS],
    text: KEY_LABEL[REPORTS],
  },
  {
    key: ACTIVITY,
    path: PATH_NAME[ACTIVITY],
    text: KEY_LABEL[ACTIVITY],
  },
  {
    key: WEBSITE,
    path: 'http://www.geneidlab.com/',
    text: KEY_LABEL[WEBSITE],
  },
];



// WEBPACK FOOTER //
// ./src/constants/paths.js